var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4884e8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.785 23.27c1.254 0 2.331-.27 3.231-.81.9-.54 1.592-1.286 2.075-2.236.483-.951.724-2.039.724-3.263l-.009-.333c-.006-.186-.015-.327-.027-.423h-4.59v1.701h2.286c-.108.744-.318 1.364-.63 1.859-.312.494-.714.863-1.206 1.107-.492.242-1.065.361-1.719.355-.87-.012-1.594-.213-2.173-.603-.58-.39-1.013-.934-1.301-1.633-.288-.7-.432-1.523-.432-2.471 0-.948.146-1.776.437-2.484.29-.708.724-1.257 1.3-1.647.576-.39 1.299-.579 2.169-.567.864 0 1.575.23 2.133.689.558.459.96 1.072 1.206 1.84L14.473 14c-.33-1.338-.961-2.377-1.894-3.118-.933-.742-2.198-1.112-3.794-1.112-1.152 0-2.187.269-3.105.806-.918.537-1.641 1.307-2.169 2.313-.528 1.005-.792 2.215-.792 3.631 0 1.08.156 2.038.468 2.875.312.838.746 1.544 1.3 2.12.556.576 1.2 1.012 1.936 1.31.735.297 1.522.445 2.362.445zM18.964 23V10.04h-2.169V23h2.169zm4.866 0v-5.4h4.554v-2.16H23.83v-3.231h5.634V10.04h-7.803V23h2.169z",
    transform: "translate(-580.000000, -3742.000000) translate(580.000000, 3742.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGif);
export default __webpack_public_path__ + "static/media/gif.f264c772.svg";
export { ForwardRef as ReactComponent };